import {ChartData} from 'chart.js';

const SEGMENT_GAP_PX = 3;
const SEGMENT_VALUE = 1;
const SEGMENT_BORDER_WIDTH_PX = 0;

export function buildChapterProgressChartData(
  total: number,
  completed: number,
  inProgress: number,
): ChartData<'doughnut'> {
  const documentStyle = getComputedStyle(document.documentElement);
  const colorGreen = documentStyle.getPropertyValue('--color-green');
  const colorBlue = documentStyle.getPropertyValue('--color-blue');
  const colorNotStarted = documentStyle.getPropertyValue('--color-gray');

  const stepColors = Array.from({length: total}, (_, i) => {
    if (i < completed) {
      return colorGreen;
    }
    if (i < completed + inProgress) {
      return colorBlue;
    }
    return colorNotStarted;
  });

  return {
    datasets: [
      {
        data: Array(total).fill(SEGMENT_VALUE),
        backgroundColor: stepColors,
        borderWidth: SEGMENT_BORDER_WIDTH_PX,
        spacing: SEGMENT_GAP_PX,
      },
    ],
  };
}
